import { useState } from 'react';
import { IconButton, MenuItem, Menu, Box } from '@mui/material';
import { styled } from '@mui/system';
import { QuickLinks } from '../communications-chat-box';
import { FormsSubmenu } from './forms-submenu';
import { TextTemplateSubmenu } from './text-template-submenu';
import BoltIcon from '@mui/icons-material/Bolt';
import CareCreditLinkQuickAction from './care-credit/care-credit-link-quick-action';

const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '8px 16px',
  height: 48
});

const StyledBox = styled(Box)({
  width: 320
});

interface QuickActionsMenuProps {
  quickLinks: QuickLinks;
  locationId?: number;
  patientId?: number;
  onSelect: (val: string) => void;
  setModalOpen: (val: boolean) => void;
  isForms2?: boolean;
}

export const QuickActionsMenu = ({ quickLinks, locationId, patientId, onSelect, setModalOpen, isForms2 }: QuickActionsMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setModalOpen(true);
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setModalOpen(false);
    setAnchorEl(null);
  };

  const handleSelect = (link: string) => {
    onSelect(link);
    handleClose();
  };

  return (
    <>
      <IconButton aria-controls='unified-inbox-quick-actions-menu-button' aria-haspopup='true' onMouseDown={handleOpen}>
        <BoltIcon />
      </IconButton>
      <Menu
        id='unified-inbox-quick-actions-menu'
        data-testid='unified-inbox-quick-actions-menu'
        anchorEl={anchorEl}
        keepMounted
        PaperProps={{ sx: { backgroundColor: '#FFFFFF' } }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <StyledBox>
          {quickLinks?.onlineSchedulingURL && (
            <StyledMenuItem
              data-testid='unified-inbox-quick-actions-menu-online-scheduling'
              onClick={() => handleSelect(quickLinks.onlineSchedulingURL!)}
            >
              Insert Online Scheduling Link
            </StyledMenuItem>
          )}
          {quickLinks?.paymentURL && (
            <StyledMenuItem
              data-testid='unified-inbox-quick-actions-menu-payments'
              onClick={() => handleSelect(quickLinks.paymentURL!)}
            >
              Insert Payment Link
            </StyledMenuItem>
          )}
          {quickLinks?.loginPortalURL && (
            <StyledMenuItem
              data-testid='unified-inbox-quick-actions-menu-login-portal'
              onClick={() => handleSelect(quickLinks.loginPortalURL!)}
            >
              Insert Patient Login Link
            </StyledMenuItem>
          )}
          <FormsSubmenu quickLinks={quickLinks} onSelect={handleSelect} locationId={locationId} patientId={patientId} isForms2={isForms2} />
          <TextTemplateSubmenu locationId={locationId} onSelect={handleSelect} />
          {quickLinks?.careCredit && (
            <CareCreditLinkQuickAction quickLinks={quickLinks.careCredit} onSelect={handleSelect} />
          )}
        </StyledBox>
      </Menu>
    </>
  );
};
